// import React, { useState } from "react";
// import Header from "../components/Header";
// import Footer from "../components/Footer";
// import { Helmet } from "react-helmet";
// import { FaArrowRight, FaFilePdf } from "react-icons/fa";

// const FinancialDocuments = () => {
//   const [startYear, setStartYear] = useState(2024);
//   const pageTitle = "Financial Documents";
//   const [activeTab, setActiveTab] = useState("return");
//    const [activeReportSubTab, setActiveReportSubTab] = useState("annual");

//   const annualReturnDocs = [
//     {
//       year: "2024",
//       date: "October 07, 2025",
//       url: "/assets/pdf/Financial_Reports/Annual_Return/BOCL_2024.pdf",
//       image: "/assets/img/Report_2.png",
//       name: "BOCL_2024",
//     },
//     {
//       year: "2023",
//       date: "October 07, 2025",
//       url: "/assets/pdf/Financial_Reports/Annual_Return/BOCL_2023.pdf",
//       image: "/assets/img/Report_1.png",
//       name: "BOCL_2023",
//     },
//     {
//       year: "2022",
//       date: "October 07, 2025",
//       url: "/assets/pdf/Financial_Reports/Annual_Return/BOCL_2022.pdf",
//       image: "/assets/img/Report_2.png",
//       name: "BOCL_2022",
//     },

//     {
//       year: "2021",
//       date: "October 07, 2025",
//       url: "/assets/pdf/Financial_Reports/Annual_Return/BOCL_2021.pdf",
//       image: "/assets/img/Report_1.png",
//       name: "BOCL_2021",
//     },
//   ];

//   const annualReportDocs = [
//     {
//       year: "2024",
//       date: "October 07, 2025",
//       url: "/assets/pdf/Financial_Reports/Annual_Report/BOCL_2023-2024.pdf",
//       image: "/assets/img/Report_1.png",
//       name: "BOCL_2023-2024"
//     },
//     {
//       year: "2023",
//       date: "October 07, 2025",
//       url: "/assets/pdf/Financial_Reports/Annual_Report/BOCL_2022-2023.pdf",
//       image: "/assets/img/Report_2.png",
//       name:"BOCL_2022-2023"
//     },
//     {
//       year: "2022",
//       date: "October 07, 2025",
//       url: "/assets/pdf/Financial_Reports/Annual_Report/BOCL_2021-2022.pdf",
//       image: "/assets/img/Report_1.png",
//       name:"BOCL_2021-2022"
//     },
//     {
//       year: "2021",
//       date: "October 07, 2025",
//       url: "/assets/pdf/Financial_Reports/Annual_Report/BOCL_2020-2021.pdf",
//       image: "/assets/img/Report_2.png",
//       name:"BOCL_2020-2021"
//     },
//   ];

//    const consolidateReportDocs = [
//     {
//       year: "2024",
//       date: "October 07, 2025",
//       url: "/assets/pdf/Financial_Reports/Consolidate_Report/BOCPL_BS_CONSOLIDATED-2024.pdf",
//       image: "/assets/img/Report_1.png",
//       name: "BOCPL_BS_CONSOLIDATED-2024"
//     },
//     {
//       year: "2023",
//       date: "October 07, 2025",
//       url: "/assets/pdf/Financial_Reports/Consolidate_Report/BOCPL_CFS_BS_2023.pdf",
//       image: "/assets/img/Report_2.png",
//       name:"BOCPL_CFS_BS_2023"
//     },
//     {
//       year: "2022",
//       date: "October 07, 2025",
//       url: "/assets/pdf/Financial_Reports/Consolidate_Report/BOCPL_Balance Sheet_CFS_2022.pdf",
//       image: "/assets/img/Report_1.png",
//       name:"BOCPL_Balance Sheet_CFS_2022"
//     },

//   ];

//   const renderDocs = (docs) => (
//    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
//       {docs.map((doc, index) => (
//         <div
//           key={index}
//           className="bg-white border-1 border-[#989898] rounded-lg shadow-sm overflow-hidden cursor-pointer hover:shadow-md transition flex flex-col"
//           onClick={() => window.open(doc.url, "_blank")}
//         >
//           {/* Top Thumbnail */}
//           <div className="!h-36 w-full border-b border-[#989898] bore !overflow-hidden bg-gray-100">
//             <img
//               src={doc.image}
//               alt={`Report ${doc.year}`}
//               className="!w-full !h-full !object-fill"
//             />
//           </div>

//           {/* Bottom Content  */}
//           <div className="px-2 mt-1 -mb-3 bg-white">
//             <div className="!flex !items-center !justify-between">
//               <div className="!flex !gap-2 items-center">
//                 <FaFilePdf className="!text-red-600 !text-lg" />
//                 <p className="!font-medium !text-sm !truncate !items-center">
//                   {doc.name}
//                 </p>
//               </div>
//               <div className="bg-gray-200 p-1 rounded-full">
//                 <FaArrowRight className="text-[#F26624] text-sm" />
//               </div>
//             </div>

//             <p className="!text-gray-500 !text-xs !-mt-3 !ml-7">{doc.date}</p>
//           </div>
//         </div>
//       ))}
//     </div>
//   );

//   return (
//     <>
// <Helmet>
//   <title>{pageTitle}</title>
// </Helmet>

// <div className="main-content">
//   <Header />

//   {/* Banner Section */}
//   <div
//     className="relative w-full h-64 md:h-80 lg:h-96"
//     style={{
//       backgroundImage: `url(/assets/img/Financial_banner.png)`,
//       backgroundSize: "cover",
//       backgroundPosition: "center",
//       width: "100%",
//     }}
//   >
//           {/* Optional overlay text */}
//           {/* <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
//             <h1 className="text-white text-3xl md:text-4xl font-bold">
//               Financial Documents
//             </h1>
//           </div> */}
//         </div>

//         {/* Content Section */}
//         <section className="py-12 bg-white">
//           <div className="container mx-auto px-4">
//             {/* Heading */}
//             <h2 className="text-2xl !font-semibold mb-4 !text-[#F26624]">
//               FINANCIAL DOCUMENTS
//             </h2>

//             {/* Main Tabs */}
//           <div className="flex gap-10 border-gray-200">
//             <button
//               className={`pb-3 font-normal relative ${
//                 activeTab === "return"
//                 ? "!text-[#F26624] !bg-transparent"
//                     : "!text-gray-500 !bg-transparent"
//               }`}
//               onClick={() => setActiveTab("return")}
//             >
//               Annual Return
//               {activeTab === "return" && (
//                 <span className="absolute left-0 bottom-0 w-full h-0.5 bg-[#F26624] rounded"></span>
//               )}
//             </button>

//             <button
//               className={`pb-3 font-normal relative ${
//                 activeTab === "report"
//               ? "!text-[#F26624] !bg-transparent"
//                     : "!text-gray-500 !bg-transparent"
//               }`}
//               onClick={() => setActiveTab("report")}
//             >
//               Annual Reports
//               {activeTab === "report" && (
//                 <span className="absolute left-0 bottom-0 w-full h-0.5 bg-[#F26624] rounded"></span>
//               )}
//             </button>
//           </div>

//           {/* Sub Tabs (Only shown when Financial Reports is active) */}
//           {activeTab === "report" && (
//             <div className="flex gap-8 mt-6 border-gray-200">
//               <button
//                 className={`pb-3 text-sm font-normal relative ${
//                   activeReportSubTab === "annual"
//                  ? "!text-[#F26624] !bg-transparent"
//                     : "!text-gray-500 !bg-transparent"
//                 }`}
//                 onClick={() => setActiveReportSubTab("annual")}
//               >
//                 Financial Report
//                 {activeReportSubTab === "annual" && (
//                   <span className="absolute left-0 bottom-0 w-full h-0.5 bg-[#F26624] rounded"></span>
//                 )}
//               </button>

//               <button
//                 className={`pb-3 text-sm font-normal relative ${
//                   activeReportSubTab === "consolidated"
//  ? "!text-[#F26624] !bg-transparent"
//   : "!text-gray-500 !bg-transparent"
//                 }`}
//                 onClick={() => setActiveReportSubTab("consolidated")}
//               >
//                 Consolidated Report
//                 {activeReportSubTab === "consolidated" && (
//                   <span className="absolute left-0 bottom-0 w-full h-0.5 bg-[#F26624] rounded"></span>
//                 )}
//               </button>
//             </div>
//           )}

//           {/* Documents */}
//           {activeTab === "return" && renderDocs(annualReturnDocs)}
//           {activeTab === "report" && activeReportSubTab === "annual" && renderDocs(annualReportDocs)}
//           {activeTab === "report" && activeReportSubTab === "consolidated" && renderDocs(consolidateReportDocs)}

//           </div>
//         </section>

//         <Footer />
//       </div>
//     </>
//   );
// };

// export default FinancialDocuments;

// approach 1

// import React, { useState } from "react";
// import { Helmet } from "react-helmet";
// import { FaArrowRight, FaFilePdf } from "react-icons/fa";
// import Header from "../components/Header";
// import Footer from "../components/Footer";

// const FinancialDocuments = () => {
//   const [activeTab, setActiveTab] = useState("annualReturn");
//     const pageTitle = "Financial Documents";

//   const annualReturnDocs = [
//     {
//       year: "2024",
//       date: "October 07, 2025",
//       url: "/assets/pdf/Financial_Reports/Annual_Return/BOCL_2024.pdf",
//       image: "/assets/img/Report_2.png",
//       name: "BOCL_2024",
//     },
//     {
//       year: "2023",
//       date: "October 07, 2025",
//       url: "/assets/pdf/Financial_Reports/Annual_Return/BOCL_2023.pdf",
//       image: "/assets/img/Report_1.png",
//       name: "BOCL_2023",
//     },
//     {
//       year: "2022",
//       date: "October 07, 2025",
//       url: "/assets/pdf/Financial_Reports/Annual_Return/BOCL_2022.pdf",
//       image: "/assets/img/Report_2.png",
//       name: "BOCL_2022",
//     },
//     {
//       year: "2021",
//       date: "October 07, 2025",
//       url: "/assets/pdf/Financial_Reports/Annual_Return/BOCL_2021.pdf",
//       image: "/assets/img/Report_1.png",
//       name: "BOCL_2021",
//     },
//   ];

//   const annualReportDocs = [
//     {
//       year: "2024",
//       date: "October 07, 2025",
//       url: "/assets/pdf/Financial_Reports/Annual_Report/BOCL_2023-2024.pdf",
//       image: "/assets/img/Report_1.png",
//       name: "BOCL_2023-2024"
//     },
//     {
//       year: "2023",
//       date: "October 07, 2025",
//       url: "/assets/pdf/Financial_Reports/Annual_Report/BOCL_2022-2023.pdf",
//       image: "/assets/img/Report_2.png",
//       name:"BOCL_2022-2023"
//     },
//     {
//       year: "2022",
//       date: "October 07, 2025",
//       url: "/assets/pdf/Financial_Reports/Annual_Report/BOCL_2021-2022.pdf",
//       image: "/assets/img/Report_1.png",
//       name:"BOCL_2021-2022"
//     },
//     {
//       year: "2021",
//       date: "October 07, 2025",
//       url: "/assets/pdf/Financial_Reports/Annual_Report/BOCL_2020-2021.pdf",
//       image: "/assets/img/Report_2.png",
//       name:"BOCL_2020-2021"
//     },
//   ];

//   const consolidateReportDocs = [
//     {
//       year: "2024",
//       date: "October 07, 2025",
//       url: "/assets/pdf/Financial_Reports/Consolidate_Report/BOCPL_BS_CONSOLIDATED-2024.pdf",
//       image: "/assets/img/Report_1.png",
//       name: "BOCPL_BS_CONSOLIDATED-2024"
//     },
//     {
//       year: "2023",
//       date: "October 07, 2025",
//       url: "/assets/pdf/Financial_Reports/Consolidate_Report/BOCPL_CFS_BS_2023.pdf",
//       image: "/assets/img/Report_2.png",
//       name:"BOCPL_CFS_BS_2023"
//     },
//     {
//       year: "2022",
//       date: "October 07, 2025",
//       url: "/assets/pdf/Financial_Reports/Consolidate_Report/BOCPL_Balance Sheet_CFS_2022.pdf",
//       image: "/assets/img/Report_1.png",
//       name:"BOCPL_Balance Sheet_CFS_2022"
//     },
//   ];

//   const tabs = [
//     { id: "annualReturn", label: "Annual Return", docs: annualReturnDocs },
//     { id: "financialReport", label: "Financial Report", docs: annualReportDocs },
//     { id: "consolidatedReport", label: "Consolidated Report", docs: consolidateReportDocs },
//   ];

//   const renderDocs = (docs) => (
//    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
//       {docs.map((doc, index) => (
//         <div
//           key={index}
//           className="bg-white border-1 border-[#989898] rounded-lg shadow-sm overflow-hidden cursor-pointer hover:shadow-md transition flex flex-col"
//           onClick={() => window.open(doc.url, "_blank")}
//         >
//           {/* Top Thumbnail */}
//           <div className="!h-36 w-full border-b border-[#989898] bore !overflow-hidden bg-gray-100">
//             <img
//               src={doc.image}
//               alt={`Report ${doc.year}`}
//               className="!w-full !h-full !object-fill"
//             />
//           </div>

//           {/* Bottom Content  */}
//           <div className="px-2 mt-1 -mb-3 bg-white">
//             <div className="!flex !items-center !justify-between">
//               <div className="!flex !gap-2 items-center">
//                 <FaFilePdf className="!text-red-600 !text-lg" />
//                 <p className="!font-medium !text-sm !truncate !items-center">
//                   {doc.name}
//                 </p>
//               </div>
//               <div className="bg-gray-200 p-1 rounded-full">
//                 <FaArrowRight className="text-[#F26624] text-sm" />
//               </div>
//             </div>

//             <p className="!text-gray-500 !text-xs !-mt-3 !ml-7">{doc.date}</p>
//           </div>
//         </div>
//       ))}
//     </div>
//   );

//   const currentDocs = tabs.find(tab => tab.id === activeTab)?.docs || [];

//   return (

//     <>
//       <Helmet>
//         <title>{pageTitle}</title>
//       </Helmet>

//       <div className="main-content">
//         <Header />

//         {/* Banner Section */}
//         <div
//           className="relative w-full h-64 md:h-80 lg:h-96"
//           style={{
//             backgroundImage: `url(/assets/img/Financial_banner.png)`,
//             backgroundSize: "cover",
//             backgroundPosition: "center",
//             width: "100%",
//           }}
//         >
//         {/* <div className="absolute inset-0 bg-black bg-opacity-20 flex items-center justify-center">
//           <h1 className="text-white text-3xl md:text-4xl font-bold">
//             Financial Documents
//           </h1>
//         </div> */}
//       </div>

//       {/* Content Section */}
//       <section className="py-12 bg-white">
//         <div className="container mx-auto px-4 max-w-7xl">
//           {/* Heading */}
//           <h2 className="text-2xl font-semibold mb-8 text-orange-600">
//             FINANCIAL DOCUMENTS
//           </h2>

//           {/* Single Level Tabs - Clean & Simple */}
//           <div className="flex flex-wrap gap-2 md:gap-6 border-gray-200">
//             {tabs.map((tab) => (
//               <button
//                 key={tab.id}
//                 className={`pb-3 px-2 font-medium text-sm md:text-base relative transition-colors ${
//                   activeTab === tab.id
//                      ? "!text-[#F26624] !bg-transparent"
//                     : "!text-gray-500 !bg-transparent"
//                 }`}
//                 onClick={() => setActiveTab(tab.id)}
//               >
//                 {tab.label}
//                 {activeTab === tab.id && (
//                   <span className="absolute left-0 bottom-0 w-full h-0.5 bg-orange-600 rounded"></span>
//                 )}
//               </button>
//             ))}
//           </div>

//           {/* Documents Grid */}
//           {renderDocs(currentDocs)}
//         </div>
//       </section>
//        <Footer />
//     </div>
//     </>

//   );
// };

// export default FinancialDocuments;

// approach 2

import React, { useState } from "react";
import { FaArrowRight, FaFilePdf, FaChevronDown } from "react-icons/fa";
import Header from "../components/Header";
import { Helmet } from "react-helmet";
import Footer from "../components/Footer";

const FinancialDocuments = () => {
  const [activeTab, setActiveTab] = useState("annualReturn");
  const [reportType, setReportType] = useState("financial");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const pageTitle = "Financial Documents";

  const annualReturnDocs = [
    {
      year: "2025",
      date: "October 07, 2025",
      url: "/assets/pdf/Financial_Reports/Annual_Return/BOCL_2024-2025.pdf",
      image: "/assets/img/Report_1.png",
      name: "BOCL_2024-2025",
    },
    {
      year: "2024",
      date: "October 07, 2025",
      url: "/assets/pdf/Financial_Reports/Annual_Return/BOCL_2024.pdf",
      image: "/assets/img/Report_2.png",
      name: "BOCL_2024",
    },
    {
      year: "2023",
      date: "October 07, 2025",
      url: "/assets/pdf/Financial_Reports/Annual_Return/BOCL_2023.pdf",
      image: "/assets/img/Report_1.png",
      name: "BOCL_2023",
    },
    {
      year: "2022",
      date: "October 07, 2025",
      url: "/assets/pdf/Financial_Reports/Annual_Return/BOCL_2022.pdf",
      image: "/assets/img/Report_2.png",
      name: "BOCL_2022",
    },
    {
      year: "2021",
      date: "October 07, 2025",
      url: "/assets/pdf/Financial_Reports/Annual_Return/BOCL_2021.pdf",
      image: "/assets/img/Report_1.png",
      name: "BOCL_2021",
    },
  ];




  const annualReportDocs = [
    {
      year: "2026",
      date: "October 16, 2026",
      url: "/assets/pdf/Financial_Reports/Annual_Report/BOCL_2025-2026.pdf",
      image: "/assets/img/Report_1.png",
      name: "BOCL_2025-2026",
    },
    {
      year: "2025",
      date: "October 07, 2025",
      url: "/assets/pdf/Financial_Reports/Annual_Report/BOCL_2024-2025.pdf",
      image: "/assets/img/Report_2.png",
      name: "BOCL_2024-2025",
    },
    {
      year: "2024",
      date: "October 07, 2025",
      url: "/assets/pdf/Financial_Reports/Annual_Report/BOCL_2023-2024.pdf",
      image: "/assets/img/Report_1.png",
      name: "BOCL_2023-2024",
    },
    {
      year: "2023",
      date: "October 07, 2025",
      url: "/assets/pdf/Financial_Reports/Annual_Report/BOCL_2022-2023.pdf",
      image: "/assets/img/Report_2.png",
      name: "BOCL_2022-2023",
    },
    {
      year: "2022",
      date: "October 07, 2025",
      url: "/assets/pdf/Financial_Reports/Annual_Report/BOCL_2021-2022.pdf",
      image: "/assets/img/Report_1.png",
      name: "BOCL_2021-2022",
    },
  ];

  const consolidateReportDocs = [
       {
      year: "2025",
      date: "October 07, 2025",
      url: "/assets/pdf/Financial_Reports/Consolidate_Report/BOC_Restated_Q1FY26_Final.pdf",
      image: "/assets/img/Report_1.png",
      name: "BOC_Restated_Q1FY26_Final",
    },
      {
      year: "2025",
      date: "October 07, 2025",
      url: "/assets/pdf/Financial_Reports/Consolidate_Report/BOC_Replace_Consolidated FS BOC 31st March 2025.pdf",
      image: "/assets/img/Report_1.png",
      name: "BOC_Consolidated FS BOC 31st March 2025",
    },
   
    {
      year: "2024",
      date: "October 07, 2025",
      url: "/assets/pdf/Financial_Reports/Consolidate_Report/BOCPL_BS_CONSOLIDATED-2024.pdf",
      image: "/assets/img/Report_1.png",
      name: "BOCPL_BS_CONSOLIDATED-2024",
    },
    {
      year: "2023",
      date: "October 07, 2025",
      url: "/assets/pdf/Financial_Reports/Consolidate_Report/BOCPL_CFS_BS_2023.pdf",
      image: "/assets/img/Report_2.png",
      name: "BOCPL_CFS_BS_2023",
    },
    {
      year: "2022",
      date: "October 07, 2025",
      url: "/assets/pdf/Financial_Reports/Consolidate_Report/BOCPL_Balance Sheet_CFS_2022.pdf",
      image: "/assets/img/Report_1.png",
      name: "BOCPL_Balance Sheet_CFS_2022",
    },
  ];

  const reportOptions = [
    { id: "financial", label: "Financial Report" },
    { id: "consolidated", label: "Consolidated Report" },
  ];

  const getCurrentDocs = () => {
    if (activeTab === "annualReturn") {
      return annualReturnDocs;
    } else {
      return reportType === "financial"
        ? annualReportDocs
        : consolidateReportDocs;
    }
  };

  const renderDocs = (docs) => (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
      {docs.map((doc, index) => (
        <div
          key={index}
          className="bg-white border-1 border-[#989898] rounded-lg shadow-sm overflow-hidden cursor-pointer hover:shadow-md transition flex flex-col"
          onClick={() => window.open(doc.url, "_blank")}
        >
          {/* Top Thumbnail */}
          <div className="!h-36 w-full border-b border-[#989898] bore !overflow-hidden bg-gray-100">
            <img
              src={doc.image}
              alt={`Report ${doc.year}`}
              className="!w-full !h-full !object-fill"
            />
          </div>

          {/* Bottom Content  */}
          <div className="px-2 mt-1 -mb-3 bg-white">
            <div className="!flex !items-center !justify-between">
              <div className="!flex !gap-2 items-center">
                <FaFilePdf className="!text-red-600 !text-lg" />
                <p className="!font-medium !text-sm !items-center max-w-[150px] whitespace-normal break-words">
                  {doc.name}
                </p>
              </div>
              <div className="bg-gray-200 p-1 rounded-full">
                <FaArrowRight className="text-[#F26624] text-sm" />
              </div>
            </div>

            <p className="!text-gray-500 !text-xs !-mt-3 !ml-7">{doc.date}</p>
          </div>

          {/* <div className="px-2 mt-1 -mb-3 bg-white">
            <div className="!flex !items-center !justify-between">
              <div className="!flex !gap-2 items-center">
                <FaFilePdf className="!text-red-600 !text-lg" />
                <p className="!font-medium !text-sm whitespace-normal break-words">
                  {doc.name}
                </p>
              </div>
              <div className="bg-gray-200 p-1 rounded-full">
                <FaArrowRight className="text-[#F26624] text-sm" />
              </div>
            </div>

            <p className="!text-gray-500 !text-xs !-mt-3 !ml-7">{doc.date}</p>
          </div> */}
        </div>
      ))}
    </div>
  );

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>

      <div className="main-content">
        <Header/>

        {/* Banner Section */}
        <div
          className="relative w-full h-64 md:h-80 lg:h-96"
          style={{
            backgroundImage: `url(/assets/img/Financial_banner.png)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "100%",
          }}
        >
          {/* <div className="absolute inset-0 bg-black bg-opacity-20 flex items-center justify-center">
          <h1 className="text-white text-3xl md:text-4xl font-bold">
            Financial Documents
          </h1>
        </div> */}
        </div>

        {/* Content Section */}
        <section className="py-12 bg-white">
          <div className="container mx-auto px-4 max-w-7xl">
            {/* Heading */}
            <h2 className="text-2xl font-semibold mb-8 !text-orange-600">
              FINANCIAL DOCUMENTS
            </h2>

            {/* Tabs with Dropdown */}
            <div className="flex items-center gap-6 border-gray-200">
              {/* Annual Return Tab */}
              <button
                className={`pb-3 px-2 font-medium text-sm md:text-base relative transition-colors ${
                  activeTab === "annualReturn"
                    ? "!text-[#F26624] !bg-transparent"
                    : "!text-gray-500 !bg-transparent"
                }`}
                onClick={() => setActiveTab("annualReturn")}
              >
                Annual Return
                {activeTab === "annualReturn" && (
                  <span className="absolute left-0 bottom-0 w-full h-0.5 bg-orange-600 rounded"></span>
                )}
              </button>

              {/* Annual Reports Tab with Dropdown */}
              <div className="relative">
                <button
                  className={`pb-3 px-2 font-medium text-sm md:text-base relative transition-colors flex items-center gap-2 ${
                    activeTab === "annualReports"
                      ? "!text-[#F26624] !bg-transparent"
                      : "!text-gray-500 !bg-transparent"
                  }`}
                  onClick={() => {
                    setActiveTab("annualReports");
                    setIsDropdownOpen(!isDropdownOpen);
                  }}
                >
                  Annual Reports
                  <FaChevronDown
                    className={`text-xs transition-transform ${
                      isDropdownOpen && activeTab === "annualReports"
                        ? "rotate-180"
                        : ""
                    }`}
                  />
                  {activeTab === "annualReports" && (
                    <span className="absolute left-0 bottom-0 w-full h-0.5 bg-orange-600 rounded"></span>
                  )}
                </button>

                {/* Dropdown Menu */}
                {isDropdownOpen && activeTab === "annualReports" && (
                  <div className="absolute !top-full left-0 mt-2 !bg-white border !border-gray-200 !rounded-lg !shadow-lg z-10 !min-w-[200px]">
                    {reportOptions.map((option) => (
                      <button
                        key={option.id}
                        className={`!w-full !text-left !px-4 !py-3 !text-sm !hover:bg-orange-50 transition-colors !first:rounded-t-lg !last:rounded-b-lg ${
                          reportType === option.id
                            ? "!text-[#F26624] !bg-transparent"
                            : "!text-gray-500 !bg-transparent"
                        }`}
                        onClick={() => {
                          setReportType(option.id);
                          setIsDropdownOpen(false);
                        }}
                      >
                        {option.label}
                        {reportType === option.id && (
                          <span className="ml-2">✓</span>
                        )}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Selected Report Type Display (when Annual Reports is active) */}
            {activeTab === "annualReports" && (
              <div className="!mt-4 !flex !items-center !gap-2 !text-sm !text-gray-600">
                <span className="font-medium">Viewing:</span>
                <span className="px-3 py-1 bg-orange-100 text-orange-600 rounded-full">
                  {reportOptions.find((opt) => opt.id === reportType)?.label}
                </span>
              </div>
            )}

            {/* Documents Grid */}
            {renderDocs(getCurrentDocs())}
          </div>
        </section>
        <Footer/>
      </div>
    </>
  );
};

export default FinancialDocuments;
